import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import "../../../assets/styles/locations.css"
const locationsData = {
    A: ["Antrim"],
    B: ["Ballymena", "Bangor", "Belfast", "Birmingham", "Bournemouth", "Bromsgrove"],
    C: ["Cardiff", "Carrickfergus", "Chippenham", "Cookstown Area", "Corby", "Corsham", "Coventry", "Craigavon", "Crawley"],
    D: ["Abingdon", "Derby", "Didcot", "Dorchester", "Downpatrick", "Wantage"],
    E: ["Enfield"],
    H: ["Hinckley"],
    K: ["Kenilworth", "Kettering", "Kidderminster"],
    L: ["Larne", "Leamington Spa", "Leicester", "Lisburn", "London", "Loughborough", "Lurgan"]
  };

const LocationsIndex = () => {
    return (
        <>

            <Bredcrum
                heading={'Our Locations'}
                path={[
                    { name: 'Our Locations', path: 'our-locations' },
                ]}
            />

            <div className="auto-container py-5 my-md-4">
                <h1 className="heading">Our Presence Throughout the UK</h1>
                <div className="grid-container">    
                    {Object.entries(locationsData).map(([initial, cities]) => (
                        <div key={initial} className="location-column">
                            <h2 className="location-initial">{initial}</h2>
                            <ul className="location-list">
                                {cities.map(city => (
                                    <li key={city} className="location-item">
                                        {city}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default LocationsIndex